/* eslint-disable camelcase */
import {
  SET_FINANCES,
  SET_SELECTION_FINANCE,
  SET_GLOBAL_FINANCES,
  SET_SELECTION_FINANCE_ENTITY,
  RESET_FINANCE
} from '../actions/types/index';


const INITIAL_STATE = {
  shop: {
    cash: [],
    stripe: [],
    total: [],
    tpe: [],
    ticket_resto: [],
    cashTab: [],
    stripeTab: [],
    totalTab: [],
    tpeTab: [],
    ticket_restoTab: [],
    details: []
  },
  global: {
    cash: [],
    stripe: [],
    total: [],
    tpe: [],
    ticket_resto: [],
    cashTab: [],
    stripeTab: [],
    totalTab: [],
    tpeTab: [],
    ticket_restoTab: [],
    details: []
  },
  selectedGraph: 'total',
  selectedTableau: 'totalTab',
  selectedEntity: 'shop'
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_FINANCES: {
      return { ...state, shop: action.payload };
    }
    case SET_GLOBAL_FINANCES: {
      return { ...state, global: action.payload };
    }
    case SET_SELECTION_FINANCE:
      return { ...state, selectedGraph: action.payload.graph, selectedTableau: action.payload.tab };
    case SET_SELECTION_FINANCE_ENTITY:
      return { ...state, selectedEntity: action.payload };
    case RESET_FINANCE:
      return INITIAL_STATE;
    default:
      return state;
  }
};
